import React, { useEffect, useRef, useState } from "react";
import { API, graphqlOperation } from "aws-amplify";
import Modal from "react-modal";
import { customModalStyles } from "../../../_shared/components/Modal/ModalStyles";
import { useZustandStore } from "_shared/utils/zustandStore";

const FormatHeaderTabName = ({
  column,
  index,
  hover,
  setHover,
  fetchPanels,
  columnsModal,
  setColumnsModal,
  tooltips,
  setLoading,
  header30DTotal,
  header90DTotal,
}) => {
  useEffect(() => {
    //Prevents scrolling for subscriptions page when remove-tickers-modal is active.
    if (columnsModal) document.body.style.overflow = "hidden";
    else document.body.style.overflow = "scroll";
  }, [columnsModal]);

  const isDraggable = column.Header !== "Position";
  const lineRef = useRef(null);

  const moneylineDays = useZustandStore((state) => state.moneylineDays);
  const setMoneylineDays = useZustandStore((state) => state.setMoneylineDays);

  function infoIcon(header) {
    if (
      [
        "Trading Range",
        "Momentum Indicator",
        "Volatility",
        "Volume",
        "Price Returns",
        "Short Interest",
        "% Change in # Shares Short",
      ].includes(header)
    ) {
      return (
        <div
          style={
            header === "Short Interest" ||
            header === "% Change in # Shares Short"
              ? { color: "white", borderColor: "white", marginTop: 15 }
              : { color: "white", borderColor: "white", marginTop: 1 }
          }
          data-tip={tooltips[header]}
          className="info-icon-2"
        >
          i
        </div>
      );
    }
  }

  const [left, setLeft] = useState(500);
  const getOffset = () => {
    setLeft(lineRef.current?.getBoundingClientRect().left + window.scrollX);
  };

  useEffect(() => {
    document.querySelector("table").addEventListener("scroll", getOffset);
    return () => {
      document.querySelector("table")?.removeEventListener("scroll", getOffset);
    };
  }, []);

  useEffect(() => {
    getOffset();
  }, [localStorage.getItem("view")]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        height: "100%",
        paddingLeft: 10,
        paddingRight: 10,
        ...(!isDraggable && { cursor: "default" }),
      }}
      data-column-index={index}
      className="draggable-content"
      onMouseOver={() => setHover({ ...hover, [column.Header]: true })}
      onMouseLeave={() => setHover({ ...hover, [column.Header]: false })}
    >
      <div
        draggable={isDraggable}
        data-column-index={index}
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          minWidth:
            column.Header === "Short Interest"
              ? 105
              : column.Header === "% Change in # Shares Short"
              ? 145
              : //header30DTotal and header90DTotal are used to keep track of the columns that are not
              //hidden in momentum indicator. the ui changes based on how many columns are still showing
              column.Header === "Momentum Indicator" &&
                header30DTotal + header90DTotal < 3
              ? 170
              : 150,
          position: "relative",
        }}
      >
        {column.Header.trim() !== "Position" && (
          <div
            draggable={isDraggable}
            data-column-index={index}
            style={{
              cursor: "pointer",
              marginTop: -1,
              position: "absolute",
              right: 0,
              color: "#75c441",
            }}
            onClick={async () => {
              setLoading(true);
              //Find the parent id
              const sectionId = await API.graphql(
                graphqlOperation(`{
                column_by_pk(id: "${column.headers[0].id}") {section_id}
              }`),
              );
              //Hide the parent id
              await API.graphql(
                graphqlOperation(`mutation {
                update_section_by_pk(pk_columns: {id: "${sectionId.data.column_by_pk.section_id}"}, _set: {hidden: true}) {id}
              }`),
              );
              //Set hover to false and refresh the table
              setHover({ ...hover, [column.Header]: false });
              fetchPanels();
              setTimeout(() => {
                setLoading(false);
              }, 2000);
            }}
          >
            ◯
            <div
              draggable={isDraggable}
              data-column-index={index}
              style={{ marginTop: -17.5 }}
            >
              -
            </div>
          </div>
        )}
        {column.Header === "Short Interest" ? (
          <div draggable={isDraggable} data-column-index={index}>
            <div draggable={isDraggable} data-column-index={index}>
              Short
            </div>
            <div draggable={isDraggable} data-column-index={index}>
              Interest
            </div>
          </div>
        ) : column.Header === "% Change in # Shares Short" ? (
          <div draggable={isDraggable} data-column-index={index}>
            <div draggable={isDraggable} data-column-index={index}>
              % Change in
            </div>
            <div draggable={isDraggable} data-column-index={index}>
              # Shares Short
            </div>
          </div>
        ) : //header30DTotal and header90DTotal are used to keep track of the columns that are not
        //hidden in momentum indicator. the ui stacks momentum indicator's name if only one
        //header is visible
        ["Momentum Indicator", "Momentum Signals"].includes(column.Header) ? (
          <div draggable={isDraggable} data-column-index={index}>
            <div draggable={isDraggable} data-column-index={index}>
              LOOKING AHEAD
            </div>
          </div>
        ) : column.Header === "Longbow Core Signal" ? (
          <div
            style={{ width: 175 }}
            draggable={isDraggable}
            data-column-index={index}
          >
            <div draggable={isDraggable} data-column-index={index}>
              Longbow Core Signal
            </div>
          </div>
        ) : ["MONEYLINE STATS"].includes(column.Header) ? (
          <div draggable={isDraggable} data-column-index={index}>
            <div
              style={{ marginTop: -17, display: "flex", flexDirection: "row" }}
              draggable={isDraggable}
              data-column-index={index}
            >
              MONEYLINE STATS
              <div
                style={{ color: "white", borderColor: "white", marginTop: 2 }}
                data-tip={tooltips[`MONEYLINE STATS`]}
                className="info-icon-2"
              >
                i
              </div>
            </div>
          </div>
        ) : (
          column.render("Header")
        )}
        <div ref={lineRef} />
        {infoIcon(column.Header)}
        {column.Header === "MONEYLINE STATS" && (
          <select
            value={moneylineDays}
            onChange={(e) => {
              setMoneylineDays(e.target.value);
            }}
            style={{
              position: "absolute",
              bottom: -17,
              fontSize: 9,
              backgroundColor: "black",
              color: "white",
              width: 112,
              outline: "none",
            }}
          >
            {[1, 2, 3, 4, 5].map((day) => (
              <option style={{ textAlign: "center" }} value={day}>
                {day}D Following Signal
              </option>
            ))}
          </select>
        )}
        {column.Header && (
          <div
            draggable={column.Header !== "Position" ? isDraggable : false}
            data-column-index={index}
            style={{
              cursor: "pointer",
              position: "absolute",
              left: 0,
              color: "#75c441",
            }}
            onClick={async () => {
              //Find the parent id
              const sectionId = await API.graphql(
                graphqlOperation(`{
                column_by_pk(id: "${column.columns[0].id}") {section_id}
              }`),
              );
              //Retrieve all columns
              const columnData = await API.graphql(
                graphqlOperation(`{
                column(where: {section_id: {_eq: "${sectionId.data.column_by_pk.section_id}"}}, order_by: {order: asc}) {
                  id
                  key
                  name
                  hidden
                }
              }`),
              );

              setColumnsModal({
                Header: column.Header,
                id: sectionId.data.column_by_pk.section_id,
                columns: columnData.data.column,
              });
            }}
          >
            ☰
          </div>
        )}
        <div ref={lineRef} style={{ position: "absolute", right: -16 }} />
        {index === 0 && (
          <div
            style={{
              position: "absolute",
              height: "calc(100vh - 330px)",
              backgroundColor: "#666",
              width: 12,
              right: -17,
              top: -18,
              pointerEvents: "none",
              borderLeft: "10px solid #050505",
            }}
          />
        )}
        {index !== 0 &&
          left >
            (localStorage.getItem("view") === "basic"
              ? 220
              : localStorage.getItem("view") === "intermediate"
              ? 230
              : localStorage.getItem("view") === "advanced"
              ? 500
              : 0) && (
            <div
              style={{
                position: "absolute",
                height: "calc(100vh - 330px)",
                backgroundColor: "#666",
                width: 2,
                right: -16,
                top: -18,
                pointerEvents: "none",
              }}
            />
          )}
      </div>
      {columnsModal && (
        <Modal
          isOpen={columnsModal.Header !== ""}
          onRequestClose={() => {
            setColumnsModal(false);
          }}
          style={customModalStyles}
          contentLabel="Ticker Modal"
        >
          <div
            className="longbow-modal"
            style={{ height: 400, overflowY: "hidden" }}
          >
            <div className="longbow-modal-header">
              {columnsModal.Header}
              <i
                onClick={() => {
                  setColumnsModal(false);
                }}
                className="fas fa-times"
              ></i>
            </div>
            <div className="longbow-modal-content">
              <div
                className="longbow-tab-options"
                style={{ height: 250, marginTop: 25 }}
              >
                {columnsModal.columns.map((obj, i) => {
                  //disable the ability to remove description and ticker in position tab.
                  //that way there will always be one row in position tab showing which
                  //prevents the Position tab from being hidden when all fields are deselected
                  if (obj.name === "Ticker") return null;
                  return (
                    <div className="option" key={i}>
                      <input
                        type="checkbox"
                        className="checkbox"
                        defaultChecked={!obj.hidden}
                        onClick={async () => {
                          obj.hidden = !obj.hidden;
                        }}
                      />
                      {/* change current to 1D under the volatility section inside the modal 
                      that lets you hide column headers */}
                      {obj.name === "Premium | Current" ||
                      obj.name === "Realized | Current"
                        ? obj.name.split("|")[0] + "| 1D"
                        : obj.name}
                    </div>
                  );
                })}
              </div>
              <div className="longbow-tab-buttons" style={{ margin: 0 }}>
                <div
                  className="longbow-button-save"
                  onClick={async () => {
                    setLoading(true);
                    if (
                      columnsModal.columns.filter((obj) => !obj.hidden).length >
                      0
                    ) {
                      await API.graphql(
                        graphqlOperation(`mutation {
                      ${columnsModal.columns.map(
                        (obj, i) =>
                          `update_column_by_pk${i}: update_column_by_pk(pk_columns: {id: "${obj.id}"}, _set: {hidden: ${obj.hidden}}) {id, name, hidden}`,
                      )}
                    }`),
                      );
                    } else {
                      await API.graphql(
                        graphqlOperation(`mutation {
                      update_section_by_pk(pk_columns: {id: "${columnsModal.id}"}, _set: {hidden: true}) {id, name, hidden}
                    }`),
                      );
                    }
                    fetchPanels();
                    setColumnsModal(false);
                    setTimeout(() => {
                      setLoading(false);
                    }, 3000);
                  }}
                >
                  Save
                </div>
                <div
                  className="longbow-button-cancel"
                  onClick={() => {
                    setColumnsModal(false);
                  }}
                >
                  Cancel
                </div>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default React.memo(FormatHeaderTabName);
